/**
 * A score marked the way a golf scorecard marks it: a circle for a birdie, two
 * for an eagle or better, a square for a bogey, two for a double bogey or
 * worse. Par is left bare. Used for gross and for net alike.
 *
 * **Classified from the CARD's par, never a submitted label** (FR-039p-1).
 *
 * **A net arrives as a decimal STRING, and only a whole one is marked.** A
 * whole number converts exactly, so the comparison is safe; a half stroke (the
 * playoff bonus, FR-034d) would need parsing a decimal in the browser, which
 * Constitution III forbids — and "a half under par" is not a birdie anyway.
 */
export function ScoreMark({
  score,
  par,
}: {
  score: number | string | null | undefined
  par?: number
}) {
  if (score === null || score === undefined) return <>–</>
  const whole = typeof score === 'number' ? score : /^-?\d+$/.test(score) ? Number(score) : null
  const kind = whole === null || par === undefined ? null : classify(whole - par)
  if (!kind) return <>{score}</>
  return (
    <span className={`score-mark score-${kind.key}`} title={kind.label}>
      {score}
    </span>
  )
}

function classify(toPar: number): { key: string; label: string } | null {
  if (toPar <= -2) return { key: 'eagle', label: toPar === -2 ? 'Eagle' : 'Albatross or better' }
  if (toPar === -1) return { key: 'birdie', label: 'Birdie' }
  if (toPar === 1) return { key: 'bogey', label: 'Bogey' }
  if (toPar >= 2)
    return { key: 'double', label: toPar === 2 ? 'Double bogey' : 'Double bogey or worse' }
  return null
}
